import React from "react";
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css'


export function Navbar() {
    return (
    <>
    <nav className="navbar">
        <ul className="items">
            <NavLink href='/'> Home </NavLink>
            <NavLink href='/projects'> Projects </NavLink>
        </ul>
    </nav>
    </>
    )
}

function NavLink({ href, children, ...props}) {
    const location = useLocation();
    const isActive =
    href === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(href);
    return (
        <li className={isActive ? 'active' : ''}>
            <Link to={href} {...props}> {children}</Link>
        </li>
    )

}